"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClerkWebhookEnvelopeSchema = exports.ClerkUserDeletedPayloadSchema = exports.ClerkUserPayloadSchema = exports.ClerkWebhookEventType = void 0;
const zod_1 = require("zod");
var ClerkWebhookEventType;
(function (ClerkWebhookEventType) {
    ClerkWebhookEventType["USER_CREATED"] = "user.created";
    ClerkWebhookEventType["USER_UPDATED"] = "user.updated";
    ClerkWebhookEventType["USER_DELETED"] = "user.deleted";
})(ClerkWebhookEventType || (exports.ClerkWebhookEventType = ClerkWebhookEventType = {}));
const ClerkEmailAddressSchema = zod_1.z.object({
    id: zod_1.z.string(),
    email_address: zod_1.z.string(),
});
const ClerkPhoneNumberSchema = zod_1.z.object({
    id: zod_1.z.string(),
    phone_number: zod_1.z.string(),
});
exports.ClerkUserPayloadSchema = zod_1.z.object({
    id: zod_1.z.string(),
    username: zod_1.z.string().nullable(),
    first_name: zod_1.z.string().nullable(),
    last_name: zod_1.z.string().nullable(),
    email_addresses: zod_1.z.array(ClerkEmailAddressSchema),
    phone_numbers: zod_1.z.array(ClerkPhoneNumberSchema),
    primary_email_address_id: zod_1.z.string().nullable(),
    primary_phone_number_id: zod_1.z.string().nullable(),
});
// Clerk's `user.deleted` webhook carries only `{ id, object, deleted }` — none of the
// profile fields above — so deletion is validated against this narrower shape instead.
exports.ClerkUserDeletedPayloadSchema = zod_1.z.object({ id: zod_1.z.string() });
// `type` is any string, not `ClerkWebhookEventType` — Clerk fires many more event types than
// webhookForClerk.ts handles (session.*, organization.*, ...), and the envelope only pins down
// `type`/`data` loosely so unrelated events fall through gracefully instead of failing schema
// validation.
exports.ClerkWebhookEnvelopeSchema = zod_1.z.object({
    type: zod_1.z.string(),
    data: zod_1.z.unknown(),
});
//# sourceMappingURL=clerkWebhook.js.map